
angular.module('gallery').controller('trackCtrl', ['$rootScope', '$timeout', '$window', function($rootScope, $timeout, $window) {
    var marks = [];
    var windowHeight = $window.innerHeight;
    var debounceTimeout;
    var contentScrolled = false;
    var meta = {
        isFirstLoad: true
    };

    //returns true if new element appears in
    // the visible area
    function checkVisibility() {

        for (var i = 0; i < marks.length; i++) {
            if (isElemVisible(marks[i])) {
                meta.slideNumber = i;
                $rootScope.$emit('updateMetaInfo', meta);
                meta.isFirstLoad = false;
                return true;
            }
        }

        return false;
    }

    function isElemVisible(mark) {
        var top = mark.elem[0].getBoundingClientRect().top;
        var isVisible = (0 <= top && top <= windowHeight);
        var result = false;

        if (!mark.isVisible && isVisible) {
            result = true;
        }

        mark.isVisible = isVisible;
        return result;
    }

    this.debounceCheckVisibility = function() {
        if (debounceTimeout) {
            $timeout.cancel(debounceTimeout);
        }
        debounceTimeout = $timeout(function() {
            checkVisibility();
        }, 100);
    };

    this.addMark = function(elem) {
        marks.push({
            elem: elem,
            isVisible: false
        });
        //commenting out fixes the add call on page load, leaving just in case we need it again.
        //this.debounceCheckVisibility();
    };

    this.setMeta = function(metaObj) {
        if (metaObj) {
            meta = metaObj;
        }
    }

}]);


// WEBPACK FOOTER //
// ./assets/components/galleryPage/scripts/shared/trackController.js